export default __webpack_public_path__ + "static/media/laundryService.7b7356ef.jpg";